/*
 * Module for deleting mulitple quick create topics at once.  It
 * may also be used for mass enabling/publishing topics.
 * This is similar to the topicsControlsModule.js
 */

define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "modules/quickCreate/quickCreateControls/quickCreateControlsView",
], function (Marionette, $, Messenger, QuickCreateControlsView) {
  var QuickCreateControlsController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "quickCreateControls";
      this.region = options.region;
    },
    show: function () {
      this.view = new QuickCreateControlsView.quickCreateControlsView();

      this.view.on(
        "delete:topics",
        function () {
          //clear any old errors
          this.view.clearError();
          //get the checked models from the sortable list (with namespace)
          var topicsToDelete = Messenger.reqres.request("quickCreate:checked:models");
          if (topicsToDelete.length > 0) {
            Messenger.yesNoDialog(
              "topics.dialog.deleteTopics",
              {
                yes: function () {
                  Messenger.vent.trigger("track:interaction", {
                    action: "Delete Topics",
                    itemCount: topicsToDelete.length,
                    object: "Topic",
                  });
                  Messenger.vent.trigger("show:saving:display");
                  this._deleteTopics(topicsToDelete);
                },
              },
              this,
            );
          } else {
            this.view.controlsError($.t("topics.controls.emptyDelete"));
          }
        },
        this,
      );

      this.showRegion(this.view);
    },
    _deleteTopics: function (topicsToDelete) {
      if (!topicsToDelete || !topicsToDelete.length) {
        Messenger.vent.trigger("close:saving:display");
        return;
      }
      var me = this;
      var topicToDelete = topicsToDelete.pop();
      topicToDelete.deleteModel({
        success: function () {
          me._deleteTopics(topicsToDelete);
        },
        error: function () {
          Messenger.vent.trigger("close:saving:display");
        },
      });
    },
  });

  return QuickCreateControlsController;
});
